import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, Col, Row, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import isEqual from 'lodash/isEqual';
import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES"
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

const DumbellPlot = ({title, data, id, refUp, refDown, popoverTitle, popoverBody}) => {
    const chartRef = useRef();
    const [showPopover, setShowPopover] = useState(false);

    const handleShowPopover = () => {
        setShowPopover(true)
    }

    const handleHidePopover = () => {
        setShowPopover(false)
    }

    useEffect(() => {
        let chart = am4core.create(chartRef.current, am4charts.XYChart);
        chart.language.locale = am4lang_es_ES;
        if(data){
            chart.data = data;
        }
        else{
            chart.data = generateChartData();
        }

        let xAxis = chart.xAxes.push(new am4charts.DateAxis());
        if( data.length === 0 ){
            let label = chart.createChild(am4core.Label);
            label.text = "No hay datos registrados";
            label.fontSize = 20;
            label.align = "center";
            label.isMeasured = false;
            label.x = am4core.percent(50);
            label.horizontalCenter = "middle";
            label.y = am4core.percent(50);
        }
        xAxis.dataFields.category = "date";
        xAxis.renderer.grid.template.location = 0;
        xAxis.renderer.minGridDistance = 15;
        xAxis.renderer.grid.template.location = 0.5;
        xAxis.renderer.grid.template.strokeDasharray = "1,3";
        xAxis.renderer.labels.template.rotation = -90;
        xAxis.renderer.labels.template.horizontalCenter = "left";
        xAxis.renderer.labels.template.location = 0.5;
        xAxis.renderer.inside = true;



        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;
        valueAxis.renderer.ticks.template.disabled = true;
        valueAxis.renderer.axisFills.template.disabled = true;
        valueAxis.min = 0;

        let refLineUp = valueAxis.axisRanges.create();
        if(refUp && refUp > 0) {
            refLineUp.value = refUp;
            refLineUp.grid.stroke = chart.colors.getIndex(4);
            refLineUp.grid.strokeDasharray = "5";
            refLineUp.grid.strokeWidth = 3;
            refLineUp.grid.strokeOpacity = 1;
            refLineUp.grid.above = true;
        }

        let refLineDown = valueAxis.axisRanges.create();
        if(refDown && refDown > 0) {
            refLineDown.value = refDown;
            refLineDown.grid.stroke = chart.colors.getIndex(0);
            refLineDown.grid.strokeDasharray = "5";
            refLineDown.grid.strokeWidth = 3;
            refLineDown.grid.strokeOpacity = 1;
            refLineDown.grid.above = true;
        }

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.dateX = "date";
        series.dataFields.openValueY = "bloodPressure";
        series.dataFields.valueY = "bloodPressure1";
        series.tooltipText = "diastólica: {openValueY.value} sistólica: {valueY.value}";
        series.sequencedInterpolation = true;
        series.fillOpacity = 0;
        series.strokeOpacity = 1;
        series.columns.template.width = 0.01;
        series.tooltip.pointerOrientation = "horizontal";

        let openBullet = series.bullets.create(am4charts.CircleBullet);
        openBullet.locationY = 1;

        let closeBullet = series.bullets.create(am4charts.CircleBullet);

        closeBullet.fill = chart.colors.getIndex(4);
        closeBullet.stroke = closeBullet.fill;

        chart.cursor = new am4charts.XYCursor();

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarY = new am4core.Scrollbar();

        return () => { chart.dispose() };
    }, [data, refUp, refDown]);

    function generateChartData() {
        let chartData = [];
        // current date
        let firstDate = new Date();
        // now set 500 minutes back
        firstDate.setMinutes(firstDate.getDate() - 500);

        // and generate 500 data items
        let bp = 110;
        let bp1;
        for (var i = 0; i < 50; i++) {
            let newDate = new Date(firstDate);
            // each time we add one minute
            newDate.setMinutes(newDate.getMinutes() + i);
            // some random number
            bp += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);
            bp1 = bp + Math.round(Math.random()*10);
            // add data item to the array
            chartData.push({
                date: newDate,
                bloodPressure: bp,
                bloodPressure1: bp1
            });
        }
        return chartData;
    }

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col lg={8} md={8}>
                        <h5>{title}</h5>
                    </Col>
                    <Col lg={4} md={4}>
                        <i className="fas fa-question-circle float-right pointer" id={id} onClick={handleShowPopover}></i>
                        <Popover placement="bottom" isOpen={showPopover} target={id} toggle={handleHidePopover}>
                            <PopoverHeader>{popoverTitle}</PopoverHeader>
                            <PopoverBody>{popoverBody}</PopoverBody>
                        </Popover>
                    </Col>
                </Row>
                <div
                    ref={chartRef}
                    style={{ height: '380px', width: '100%' }}
                />
            </CardBody>
        </Card>
    )
}

export default React.memo(DumbellPlot, (prevProps, nextProps) => isEqual(prevProps, nextProps));
